<template lang='pug'>
  .digi-divider.component
</template>

<script>
  export default {
    name: 'digi-divider'
  }
</script>

<style lang='stylus'>
  .digi-divider
    width 100%
    border-top 1px solid rgba( 0 0 0 .05 )
    border-bottom 1px solid rgba( 255 255 255 .75 )
    .text
      display none

    &.on-dark
      border-top 1px solid rgba( 0 0 0 .25 )
      border-bottom 1px solid rgba( 255 255 255 .02 )

    &.page
      margin 64px 0
      &.with-text
        margin-bottom 56px

    &.section
      margin 32px 0
      &.with-text
        margin-bottom 24px

    &.card
      margin 16px 0

    &.tight
      margin 8px 0

    &.borderless
      border 0
    
  .digi-divider.vertical
    display inline
    @extends .digi-divider.borderless
    margin 0 12px
    border-right 1px solid rgba( 0 0 0 .05 )
    border-left 1px solid rgba( 255 255 255 .75 )
    &.on-dark
      border-left 1px solid rgba( 0 0 0 .75 )
      border-right 1px solid rgba( 255 255 255 .02 )
    &.borderless
      border 0
</style>
